import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { List, PageHeader, Typography } from 'br2s-ui-componentlibrary_r2_02';
import Container from '@/components/Container/Container';
import { SECTIONS } from './privacy-statement-constants';
import '../FooterPage.scss';

const renderSections = ({
  id,
  data,
}: {
  id: string;
  data: (string | { text: string; child: string[] })[];
}) => (
  <div className="section" key={id}>
    <List maxList={10} id={`${id}-list`} type="alphanumeric" data={data} />
  </div>
);

const PrivacyStatement = () => {
  const navigate = useNavigate();

  // istanbul ignore next
  useLayoutEffect(() => {
    const lis = Array.from(document.querySelectorAll('li'));
    const li = lis[lis.length - 3];
    const child = li.childNodes[0];

    const link = document.createElement('a');
    link.setAttribute('href', 'mailto:ACRA_QSM@acra.gov.sg');
    link.classList.add('underlined');
    link.innerText = 'ACRA_QSM@acra.gov.sg';

    // istanbul ignore next
    if (child.textContent) {
      const [one, two] = child.textContent.split('ACRA_QSM@acra.gov.sg');

      const div = document.createElement('div');
      div.classList.add('cmp-list-ol--content');
      div.appendChild(document.createTextNode(one));
      div.appendChild(link);
      div.appendChild(document.createTextNode(two));

      li.replaceChild(div, child);
    }
  }, []);

  return (
    <div className="footer-page-container">
      <PageHeader
        id="privacy-statement"
        title="Privacy statement"
        breadcrumbData={[
          {
            label: 'Home',
            onClick: () => navigate('/ '),
          },
          { label: 'Privacy statement' },
        ]}
      />
      <Container>
        <div className="container">
          <div className="footer-page-content">
            <div className="part-one privacy-content">
              <Typography
                type="headline-3"
                label="Government of Singapore Privacy Statement"
                weight="bold"
              />
              {SECTIONS.map(renderSections)}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default PrivacyStatement;
